module.exports = __webpack_public_path__ + "static/media/guru-nanak-dev-ji.6dd4f4b0.png";